package com.tregz.polyglot.di

class SecretsJs : Secrets {

    override fun getEnv(key: String): String {
        return when (key) {
            Secrets.GEMINI_API_KEY -> getGeminiApiKey()
            else -> ""
        }
    }

    private fun getGeminiApiKey(): String {
        return try {
            js("process.env['${Secrets.GEMINI_API_KEY}']") as? String ?: ""
        } catch (_: Throwable) {
            ""
        }
    }
}

actual val secrets: Secrets = SecretsJs()
